module.exports = __webpack_public_path__ + "static/media/bhm.22e98252.png";